module.exports = __webpack_public_path__ + "static/media/homepage_expand_alliance_section.72df2b61.png";